var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{staticClass:"elevation-0",attrs:{"height":"45","color":"gray"}},[_c('v-toolbar-title',[_c('h1',{staticClass:"subheading"},[_vm._v("Lead Status")])])],1),_c('div',{attrs:{"id":"lead-pie"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }